import { type FC, useId } from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '~/components/Tooltip';

import { IconButton } from '../../ui/IconButton';

import { actionIconClass, disabledActionClass } from '../constants';

interface DiscussionOffButtonProps {
  label: string;
  icon: FC<{ className?: string }>;
}

export const DiscussionOffButton: FC<DiscussionOffButtonProps> = ({ label, icon: Icon }) => {
  const { t } = useTranslation();
  const reason = t('community.content_page.discussion_off');
  const reasonId = useId();

  return (
    <Tooltip content={reason} placement="top-start" interactive className="flex">
      <IconButton aria-label={label} aria-describedby={reasonId} aria-disabled className={disabledActionClass}>
        <Icon className={actionIconClass} />
        <span id={reasonId} className="sr-only">
          {reason}
        </span>
      </IconButton>
    </Tooltip>
  );
};
